import styled from "styled-components";

export const Observer = styled("div")``;
